// extracted by mini-css-extract-plugin
export default {"blockStatistic":"ButtonLinkTgStat_blockStatistic__nrLdS","btnStat":"ButtonLinkTgStat_btnStat__3AjNQ","TgStatImg":"ButtonLinkTgStat_TgStatImg__1awAC"};